module.exports = __webpack_public_path__ + "img/mobileclose.8aade5fb.svg";